export default __webpack_public_path__ + "static/media/ecom.24038cfe.svg";